import React from 'react';
import { elakayAutoText } from './dataElakay';
import './SimulationTaxInput.css';

export const simulationTaxText = (infoSource, key, fallback) =>
    infoSource?.laguangeElakay?.('frontElakayAutoText', infoSource.languageAPI)?.[key]
    || elakayAutoText(key, fallback);

// Rates stay fractional everywhere in the API/model; only the field shows %.
export default function SimulationTaxInput({ value = 0, onChange, infoSource, disabled = false, className = '' }) {
    const label = simulationTaxText(infoSource, 'h_ps_tax_rate', 'Applicable sales tax (%)');
    return (
        <label className={`simulation-tax-field ${className}`}>
            <span>{label}</span>
            <input type="number" inputMode="decimal" min="0" max="100" step="0.001"
                aria-label={label} disabled={disabled}
                value={value === '' ? '' : Number((Number(value) * 100).toFixed(6))}
                onChange={event => {
                    const raw = event.target.value;
                    const percent = Number(raw);
                    if (Number.isFinite(percent) && percent >= 0 && percent <= 100) {
                        onChange(raw === '' ? '' : percent / 100);
                    }
                }} />
        </label>
    );
}
